import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DxFormComponent } from 'devextreme-angular';
import { ToastrService } from 'ngx-toastr';
import { RawFileModel } from 'src/app/models/raw-file-model';
import { TenantCreationModel } from 'src/app/models/tenants/tenant-creation-model';
import { AdministrationService } from 'src/app/services/administration.service';
import { AdminAuthenticationService } from 'src/app/services/admin-authentication.service';
import { LoadingService } from 'src/app/services/loading.service';

@Component({
  selector: 'app-create-tenant',
  templateUrl: './create-tenant.component.html',
  styleUrl: './create-tenant.component.scss',
  standalone: false
})
export class CreateTenantComponent implements OnInit {
  @ViewChild('form', { static: false })
  form!: DxFormComponent;

  isAuthenticated = false;
  isLoaded = false;

  formData: TenantCreationModel = {
    tenantName: '',
    tenantDescription: '',
    lastName: '',
    firstName: '',
    email: '',
    cloneDataFromSourceTenant: false,
    file: null,
    domains: []
  };

  imagePreview: string | null = null;

  constructor(
    private administrationService: AdministrationService,
    private adminAuthenticationService: AdminAuthenticationService,
    private toastrService: ToastrService,
    private translateService: TranslateService,
    private loadingService: LoadingService
  ) {}

  ngOnInit(): void {
    this.checkAuthentication();
  }

  private checkAuthentication(): void {
    this.adminAuthenticationService
      .checkAuthentication()
      .subscribe({
        next: () => {
          this.isAuthenticated = true;
          this.isLoaded = true;
        },
        error: () => {
          this.isAuthenticated = false;
          this.isLoaded = true;
        }
      });
  }

  onLoginSuccess(): void {
    this.isAuthenticated = true;
  }

  createTenant = () => {
    const isFormValid = this.form.instance.validate().isValid;

    if (!isFormValid) {
      return;
    }

    if (!this.formData.file) {
      this.toastrService.error(
        this.translateService.instant('VALIDATIONS.IMAGE-REQUIRED')
      );
      return;
    }

    this.loadingService
      .load(this.administrationService.createTenant(this.formData))
      .subscribe({
        next: () => {
          this.toastrService.success(
            this.translateService.instant(
              'TENANTS.TENANT-CREATED-SUCCESSFULLY'
            )
          );
        },
        error: (error) => {
          this.toastrService.error(
            this.translateService.instant(
              'COMMON.AN-ERROR-HAS-OCCURRED'
            )
          );

          console.error('Error creating tenant:', error);
        }
      });
  };

  onImageUploaded(files: File[]): void {
    if (!files || files.length === 0) {
      return;
    }

    const file = files[0];

    this.imagePreview = URL.createObjectURL(file);

    const reader = new FileReader();

    reader.onload = () => {
      const base64 = (reader.result as string).split(',')[1];

      const rawFile: RawFileModel = {
        name: file.name,
        dataBase64: base64
      };

      this.formData.file = rawFile;
    };

    reader.readAsDataURL(file);
  }
}